// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".related-posts .title{font-family:Fira Sans Condensed, Rubik, Helvetica, Arial Narrow, Arial, sans-serif;font-size:1rem;font-weight:700;text-transform:uppercase;line-height:1.5;letter-spacing:-0.025em;--tw-text-opacity:1;color:rgb(0 103 171 / var(--tw-text-opacity))}.related-posts ul{margin-top:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
